import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "link-button",
  "use": "link-button-usage",
  "viewBox": "0 0 510 510",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 510 510\" id=\"link-button\">\r\n<g>\r\n\t<g id=\"link-button_link\">\r\n\t\t<path d=\"M153,280.5h204v-51H153V280.5z M48.45,255c0-58.65,45.9-104.55,104.55-104.55h76.5V102H153C68.85,102,0,170.85,0,255\r\n\t\t\tc0,84.15,68.85,153,153,153h76.5v-48.45H153C94.35,359.55,48.45,313.65,48.45,255z M357,102h-76.5v48.45H357\r\n\t\t\tc58.65,0,104.55,45.9,104.55,104.55c0,58.65-45.899,104.55-104.55,104.55h-76.5V408H357c84.15,0,153-68.85,153-153\r\n\t\t\tC510,170.85,441.15,102,357,102z\" />\r\n\t</g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/svg/link-button.svg
// module id = 243
// module chunks = 0